import axios from 'axios';

import { API_URL } from '../config';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  }
});

export interface PublicHoliday {
  id: number;
  name: string;
  date: string;
  created_at: string;
  updated_at: string;
}

export const publicHolidayService = {
  getAllHolidays: async (): Promise<PublicHoliday[]> => {
    const response = await api.get('/public-holidays');
    return response.data;
  },

  createHoliday: async (name: string, date: string): Promise<PublicHoliday> => {
    const response = await api.post('/public-holidays', {
      name,
      date
    });
    return response.data;
  },

  updateHoliday: async (id: number, data: { name: string; date: string }): Promise<PublicHoliday> => {
    const response = await api.put(`/public-holidays/${id}`, data);
    return response.data;
  },

  deleteHoliday: async (id: number): Promise<void> => {
    await api.delete(`/public-holidays/${id}`);
  }
}; 